export const creditTypes = {
    PERSONAL:"اعتبار شخصی",
    SPONSOR:"شرکت",
    INCOME:"درآمد",
    NON_WITHDRAWABLE:"جیم پین"

}
